import { Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import LeftArrow from '../../../../../../../asset/svg/leftArrow.svg';
import '../../../../../../../scss/pages/Attendance/Component/Asset/Assets/De-Register Asset/De Register Asset/deregister_asset.scss';
import { DE_REGISTERED_ASSET_PATH, DE_REGISTER_ASSET_INFO_PATH } from '../../../../../../../utils/Constants';
import ClearIcon from '@mui/icons-material/Clear';
import { CLEAR_DE_REGISTER_ASSET_STATE, DELETE_DE_REGISTER_ASSET_LIST, DELETE_FILETR_DE_REG_ASSET_DATA, GET_OTP_DE_REGISTER_ASSET } from '../../../../../../../sagas/type';
import { useSnackbar } from 'notistack';

function Deregister_asset(props) {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { DeRegisterAssetList, SelectedStoreDatas } = useSelector(mapStateToProps);
  const dispatch = useDispatch()

  const handleBack = () => {
    navigate(DE_REGISTER_ASSET_INFO_PATH)
  }

  const handleClearRegisterAsset = (id) => {
    if (id) {
      dispatch({
        type: DELETE_DE_REGISTER_ASSET_LIST,
        payload: id,
      })
      dispatch({
        type: DELETE_FILETR_DE_REG_ASSET_DATA,
        payload: { SelectedAssetId: id },
      })
    }
  }

  const handleDeRegisterMore = () => {
    navigate(DE_REGISTERED_ASSET_PATH)
  }

  const handleContinue = () => {
    dispatch({
      type: GET_OTP_DE_REGISTER_ASSET,
      payload: { storeData: SelectedStoreDatas },
      enqueueSnackbar: enqueueSnackbar,
      navigate: navigate,
    })

  }

  return (
    <div className='De-Register-Asset-Container' >
      <div className='De-Register-Asset-Container_header'>
        <div className='De-Register-Asset-Container_head-height '>
          <img className='De-Register-Asset-Container_header_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp;
          <span className='De-Register-Asset-Container_header_content'>Deregister Asset</span>
        </div>
      </div>

      <div className='De-Register-Asset-Container_Overflow-Container'>
        {DeRegisterAssetList?.length > 0 && DeRegisterAssetList?.map((item) => {
          return (
            <div key={item?.id} className='De-Register-Asset-Container_card-Parent-Container'>
              <div className="De-Register-Asset-Container_card-Heading">
                <div className='De-Register-Asset-Container_card-Heading_child' >
                  <Typography sx={{ color: 'rgba(255, 255, 255, 0.40)', fontWeight: 400, fontSize: '11px' }}>Assets Name</Typography>
                  <Typography sx={{ color: "#FFF", fontWeight: 600, fontSize: '14px', marginTop: "2px" }} value="name">{item?.assetName}</Typography>
                </div>
              </div>
              <div className="De-Register-Asset-Container_card-Heading">
                <div className='De-Register-Asset-Container_card-Heading_child'>
                  <Typography sx={{ color: 'rgba(255, 255, 255, 0.40)', fontWeight: 400, fontSize: '11px' }}>Assets ID</Typography>
                  <Typography sx={{ color: "#FFF", fontWeight: 600, fontSize: '14px', marginTop: "2px" }} value="name">{item?.assetId}</Typography>
                </div>
              </div>
              <div>
                <ClearIcon sx={{ color: 'rgba(255, 255, 255, 0.30)', width: "16px", height: "16px", position: "absolute", right: "13px", top: "10px" }} onClick={() => handleClearRegisterAsset(item?.id)} />
              </div>
            </div>
          )
        })}
      </div>

      <div className='De-Register-Asset-Container_registerAssetData_buttonContainer'>
        <button type='submit' className='De-Register-Asset-Container_registerAssetData_buttonContainer_active-button-reg-more' onClick={handleDeRegisterMore}>DeRegister More</button>
        <button type='submit' className='De-Register-Asset-Container_registerAssetData_buttonContainer_active-button' onClick={handleContinue}>Continue</button>
      </div>
    </div >
  )
}
const mapStateToProps = (state) => {
  return {
    DeRegisterAssetList: state?.attendanceConfig?.DeRegisterAssetList,
    SelectedStoreDatas: state?.attendanceConfig?.SelectedStoreDatas,
  }
}
export default Deregister_asset